import axios from "axios";

export const getWebhookList = async ({ queryKey }) => {

    const [, businessId, token] = queryKey;

    const response = await axios.get(process.env.REACT_APP_API_URL + '/webhook/' + businessId,
        {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    return response;
}

export const addWebhook = (values) => {
    const response = axios.post(process.env.REACT_APP_API_URL + '/webhook/' + values.businessId, values.body,
        {
            headers: {
                "Authorization": `Bearer ${values.token}`
            }
        }
    );
    return response;
}

export const modifyWebhook = (values) => {
    const response = axios.put(process.env.REACT_APP_API_URL + '/webhook/' + values.webhookId, values.body,
        {
            headers: {
                "Authorization": `Bearer ${values.token}`
            }
        }
    );
    return response;
}

export const deleteWebhook = (values) => {
    const response = axios.delete(process.env.REACT_APP_API_URL + '/webhook/' + values.webhookId,
        {
            headers: {
                "Authorization": `Bearer ${values.token}`
            }
        }
    );
    return response;
}